import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EmailTemplate } from '../../../services/communication-service/communication.service';

/**
 * Galeria de templates do disparo pontual. O administrador escolhe, nunca edita
 * — o corpo do e-mail é o que a equipe de criação entregou. Esta tela não tem
 * relação nenhuma com status de pedido: lista todos os templates ativos.
 */
@Component({
  selector: 'app-template-picker',
  standalone: false,
  templateUrl: './template-picker.html',
  styleUrl: './template-picker.scss',
})
export class TemplatePicker {
  templates: EmailTemplate[] = [];
  selecionadoId: number | null = null;

  /** Qual card está com a pré-visualização aberta. */
  expandidoId: number | null = null;

  /**
   * Pré-visualizações resolvidas uma única vez, por id. Sanitizar dentro do
   * template devolveria um objeto novo a cada verificação e o `iframe`
   * recarregaria sem parar.
   *
   * O HTML roda em `iframe` com `sandbox`, que bloqueia scripts e acesso à mesma
   * origem — o mesmo mecanismo da pré-visualização do HTML importado.
   */
  private previews = new Map<number, SafeHtml>();

  readonly dialogRef = inject(MatDialogRef<TemplatePicker>);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { templates: EmailTemplate[]; selecionadoId: number | null },
    private sanitizer: DomSanitizer,
  ) {
    this.templates = (data.templates || []).filter((template) => template.ativo);
    this.selecionadoId = data.selecionadoId ?? null;

    this.templates.forEach((template) => {
      if (template.html) {
        this.previews.set(template.id, this.sanitizer.bypassSecurityTrustHtml(template.html));
      }
    });
  }

  alternarPreview(template: EmailTemplate) {
    this.expandidoId = this.expandidoId === template.id ? null : template.id;
  }

  htmlSeguro(template: EmailTemplate): SafeHtml | null {
    return this.previews.get(template.id) ?? null;
  }

  escolher(template: EmailTemplate) {
    this.dialogRef.close(template);
  }

  cancelar() {
    this.dialogRef.close();
  }
}
